var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('egranty-section-divider',{attrs:{"small":true,"text":"Typ projektu","icon":"list"}}),_c('v-card-text',[_c('display-text-component',{attrs:{"label":"Typ projektu","value":_vm.projectTypeName,"flex":"full-width"}})],1)],1)}
var staticRenderFns = []

export { render, staticRenderFns }